

export default {
    // 适用对象数据
    applicableObjectsList: [
        {
            title: '直接用户',
            list: [
                {
                    img: require('@/assets/images/landing-ofd/obj_bank2x.png'),
                    textAll: '银行',
                    textOne: '银行'
                },
                {
                    img: require('@/assets/images/landing-ofd/obj_guarantee2x.png'),
                    textAll: '担保公司',
                    textOne: '担保公司'
                },
                {
                    img: require('@/assets/images/landing-ofd/obj_insurance2x.png'),
                    textAll: '保险公司',
                    textOne: '保险公司'
                }
            ]
        },
        {
            title: '平台机构',
            list: [
                {
                    img: require('@/assets/images/landing-ofd/obj_trading2x.png'),
                    textAll: '公共资源交易中心',
                    textOne: '公共资源',
                    textTwo: '交易中心'
                },
                {
                    img: require('@/assets/images/landing-ofd/obj_platform2x.png'),
                    textAll: '电子保函服务平台',
                    textOne: '电子保函',
                    textTwo: '服务平台'
                },
                {
                    img: require('@/assets/images/landing-ofd/obj_integrators2x.png'),
                    textAll: '电子保函系统集成商',
                    textOne: '电子保函',
                    textTwo: '系统集成商'
                }
            ]
        }
    ],
    // 解决方案
    solutionList: [
        {
            title: '保函文件生成',
            img: require('@/assets/images/landing-ofd/solution_one.png')
        },
        {
            title: '保函格式转换',
            img: require('@/assets/images/landing-ofd/solution_two.png')
        },
        {
            title: '加密保函盖章',
            img: require('@/assets/images/landing-ofd/solution_three.png')
        },
        {
            title: '明文保函追加',
            img: require('@/assets/images/landing-ofd/solution_four.png')
        },
        {
            title: '合并保函盖章',
            img: require('@/assets/images/landing-ofd/solution_five.png')
        },
        {
            title: '保函签章验真',
            img: require('@/assets/images/landing-ofd/solution_six.png')
        },
        {
            title: '签章证书管理',
            img: require('@/assets/images/landing-ofd/solution_seven.png')
        },
    ],
    // 方案优势
    planAdvantageList: [
        {
            img: require('@/assets/images/landing-ofd/plan_ofd2x.png'),
            text: '前沿OFD技术',
            desc: '保函盖章、追加、合并、再盖章，全部印章有效'
        },
        {
            img: require('@/assets/images/landing-ofd/plan_xinchuang2x.png'),
            text: '信创目录产品',
            desc: '支持信创、非信创环境部署使用，节约改造成本'
        },
        {
            img: require('@/assets/images/landing-ofd/plan_case2x.png'),
            text: '落地案例丰富',
            desc: '用户覆盖银行、保险、担保公司、保函系统商等'
        },
    ],
    // 典型案例
    typicalCasesList: [
        {
            img: require('@/assets/images/landing-ofd/logo_one2x.png')
        },
        {
            img: require('@/assets/images/landing-ofd/logo_two2x.png')
        },
        {
            img: require('@/assets/images/landing-ofd/logo_three2x.png')
        },
        {
            img: require('@/assets/images/landing-ofd/logo_four2x.png')
        }
    ]
}
